import * as API from '@/api'
import request from './index'

//获取订单列表
export function getList(params) {
    return request.get(API.ORDER_LIST, {
        params
    })
}

/*
数据统计
 */
export function getCount(params) {
    return request.get(API.ORDER_COUNT, {
        params
    })
}
